import { MetricType } from 'components/common/types/DrilldownReports.types';
import {
  TransformedPublisherFeatures,
  PublisherFeatures,
  TransformedPublisherDirectSalesPricing,
  PublisherReportConfiguration,
  PublisherFrameListConfiguration,
} from 'components/common/types/Publisher.types';

export const emptyDirectSalesPricing: TransformedPublisherDirectSalesPricing = {
  type: '',
  startDay: '',
  ids: [],
  pivotFields: [],
  reportingFields: [],
};

export const convertToArrayOfMarketsForIndividualFeatureFlag = (
  featuresResponse: PublisherFeatures,
): TransformedPublisherFeatures => {
  return Object.keys(featuresResponse).reduce((acc, featureName) => {
    const envIds = featuresResponse[featureName].replace(/ /g, '').split(',');
    acc[featureName] = envIds;
    return acc;
  }, {} as TransformedPublisherFeatures);
};

export const convertReportConfigurationToJSONObject = (reportConfiguration?: string): PublisherReportConfiguration => {
  if (!reportConfiguration) return { metricType: MetricType.FRAMES };

  try {
    const json = JSON.parse(reportConfiguration);

    if (!json.configuration?.defaultMetric || !Object.values(MetricType).includes(json.configuration.defaultMetric)) {
      return { metricType: MetricType.FRAMES };
    }

    return {
      metricType: json.configuration.defaultMetric,
    };
  } catch (error) {
    return { metricType: MetricType.FRAMES };
  }
};

export const convertFrameListConfigurationToJSONObject = (
  frameListConfiguration?: string,
): PublisherFrameListConfiguration => {
  if (!frameListConfiguration) return { metadataFields: [] };

  try {
    const json = JSON.parse(frameListConfiguration);

    if (!json.configuration?.metadataFields) {
      return { metadataFields: [] };
    }

    return {
      metadataFields: json.configuration.metadataFields,
    };
  } catch (error) {
    return { metadataFields: [] };
  }
};

export const convertPricingToJSONObject = (gridConfiguration?: string): TransformedPublisherDirectSalesPricing => {
  const emptyJson = emptyDirectSalesPricing;

  if (!gridConfiguration) return emptyJson;

  try {
    const json = JSON.parse(gridConfiguration);

    if (!json.configuration) return emptyJson;

    return { ...emptyJson, ...json.configuration };
  } catch (error) {
    return emptyJson;
  }
};
